export default "__VITE_ASSET__1f0799bc__"